import React, { Component } from 'react';

class HydrationDayGoalHeader extends Component {
    render() {
        return (
            <div className="goal-header placeholder">
                goal header placeholder
            </div>
        );
    }
}

export default HydrationDayGoalHeader;
